<template>
  <div class="create-team">
    <el-form
      v-loading="loading"
      :model="approverForm"
      :rules="rules"
      ref="approverForm"
      class="white-bg form"
      label-position="left"
      label-width="200px"
    >
      <div class="flex flex-v-center flex-h-bet">
        <h3 class="text-gray bold mt-0 mb-40">
          {{ !isEdit ? "Create" : "Edit" }} Approver
        </h3>
        <div class="btn-wrapper mb-10 mr-20 move-right">
          <router-link
            to="/admin/attendance/overtime/settings/approver"
            class="btn-back"
          >
            <span>Back</span>
          </router-link>
        </div>
      </div>
      <div class="mt-20 border">
        <el-form-item prop="group_name" label="Group Name">
          <el-input
            placeholder="Enter group name"
            v-model="approverForm.group_name"
          ></el-input>
        </el-form-item>
      </div>

      <div class="mt-20">
        <h3 class="text-gray bold mt-0 mb-40">Set Approver</h3>

        <el-form-item prop="approvers_count" label="Set Additional Approver">
          <el-input-number v-model="approvers_count" :min="1"></el-input-number>
        </el-form-item>
        <div
          class="mt-20"
          v-for="(item, i) in approverForm.approval_details"
          :key="item.id"
        >
          <el-form-item
            :prop="'approval_details.' + i + '.approval_person_id'"
            :label="'Approver Name ' + (i + 1)"
            :rules="{
              required: true,
              message: 'Please select approver person',
              trigger: 'blur',
            }"
          >
            <el-select
              v-model="approverForm.approval_details[i]['approval_person_id']"
              placeholder="Select Approver"
              filterable
              remote
              :remote-method="searchEmployees"
            >
              <el-option
                v-for="employee in employees"
                :key="employee.id"
                :label="employee.name"
                :value="employee.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :prop="'approval_details.' + i + '.alt_approval_person_id'"
            :label="'Alt Approver Name ' + (i + 1)"
          >
            <el-select
              v-model="
                approverForm.approval_details[i]['alt_approval_person_id']
              "
              placeholder=" Select Alt Approver"
              filterable
              remote
              :remote-method="searchEmployees"
            >
              <el-option
                v-for="employee in employees"
                :key="employee.id"
                :label="employee.name"
                :value="employee.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item
          class="mt-20"
          label="Approver Type"
          v-if="approvers_count > 0"
        >
          <el-radio-group v-model="approverForm.approval_types" class="mt-10">
            <el-radio label="Concurrent">Concurrent</el-radio>
            <el-radio label="Sequential">Sequential</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>

      <div class="mt-20 mb-20">
        <div class="btn-wrapper mt-20 sec-span">
          <el-button
            class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
            @click.prevent="create()"
            :loading="loading"
            >{{ !isEdit ? "Create" : "Save Changes" }}</el-button
          >
          <button class="btn-cancel mr-15" @click.prevent="$router.go(-1)">
            Cancel
          </button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import debounce from "lodash.debounce";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");
export default {
  data() {
    return {
      isEdit: false,
      loading: false,
      approverForm: {
        group_name: "",
        approval_types: "Concurrent",
        approval_details: [
          {
            approval_person_id: null,
            alt_approval_person_id: null,
          },
        ],
      },
      approvers_count: null,
      employees: [],
      rules: {
        group_name: [
          {
            required: true,
            message: "Please input Approval name",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    approvers_count: function(newValue, oldValue) {
      if (newValue === this.approverForm.approval_details.length) {
        return;
      }
      if (newValue === oldValue + 1) {
        this.approverForm.approval_details.push({
          approval_person_id: null,
          alt_approval_person_id: null,
        });
        return;
      }
      this.approverForm.approval_details = this.approverForm.approval_details.slice(
        0,
        newValue
      );
    },
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.fetchApprover(id);
    }
    this.isEdit = id ? true : false;
  },
  methods: {
    ...mapActions(["createApprover", "updateApprover", "getApproverById"]),
    fetchApprover(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getApproverById", id)
        .then(response => {
          this.loading = false;
          const {
            group_name,
            approvers_count,
            approval_types,
            approvalLevels,
          } = response.data;

          this.approvers_count = approvers_count;
          const formattedApprovalLevels = approvalLevels.map(x => ({
            ...x,
            id: x.approval_person_id,
            alt_id: x.alt_approval_person_id,
            alt_approval_person_id: x.alt_approval_person,
            approval_person_id: x.approval_person_name,
          }));
          this.approverForm = {
            ...this.approverForm,
            group_name,
            approval_types,
            approval_details: formattedApprovalLevels,
          };
        })
        .catch(() => {
          this.loading = false;
        });
    },
    create() {
      this.$refs[`approverForm`].validate(valid => {
        if (valid) {
          this.loading = true;

          if (this.isEdit) {
            const id = this.$route.params.id;

            this.approverForm.approval_details = this.approverForm.approval_details.map(
              x => {
                return {
                  approval_person_id:
                    typeof x.approval_person_id === "string"
                      ? x.id
                      : x.approval_person_id,
                  alt_approval_person_id:
                    typeof x.alt_approval_person_id === "string"
                      ? x.alt_id
                      : x.alt_approval_person_id,
                };
              }
            );
            const inputData = {
              ...this.approverForm,
              group_name: this.approverForm.group_name,
              approval_details: this.approverForm.approval_details,
              approval_types: this.approverForm.approval_types,
            };
            this.$store
              .dispatch("admin/attendance/overtime/updateApprover", {
                data: inputData,
                id,
              })
              .then(() => {
                this.loading = false;
                this.$router.push(
                  "/admin/attendance/overtime/settings/approver"
                );
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            const inputData = {
              ...this.approverForm,
            };
            this.$store
              .dispatch("admin/attendance/overtime/createApprover", inputData)
              .then(() => {
                this.loading = false;
                this.$router.push(
                  "/admin/attendance/overtime/settings/approver"
                );
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    searchEmployees: debounce(function(searchQuery) {
      this.$store
        .dispatch("searchEmployees", searchQuery)
        .then(response => {
          this.employees = response;
        })
        .catch(() => {});
    }, 500),
  },
};
</script>

<style scoped>
.el-select.inline-select {
  width: 20% !important;
}
</style>
